module.exports = "https://www.gc-qa.gnp.com.mx/d81e6e5a3e703bcc8180c1b81a153128.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mas.png
// module id = 984
// module chunks = 0 1